import { InjectionToken } from '@angular/core';

export const AVATARS_API_URL = new InjectionToken<string>('Avatars Api Url');
